jQuery(document).ready(function ($) {
    const inputs = $('.form-row input.input-text, .form-row .woocommerce-input-wrapper input.input-text, .form-row input.wpcf7-form-control, .form-row textarea.wpcf7-form-control');
    const selects = $('.form-row .woocommerce-input-wrapper select, .form-row select.input-select');

    const vetSlidingLabels = {
        init: function() {

        },
        addSlidingLabels: function(inputs) {
            if ( inputs.length > 0 ) {
                inputs.each((index, element) => {
                    const me = $(element);

                    if ( me.val() == ""){
                        $("label[for='"+me.attr('id')+"']").removeClass("animate-label");
                    } else {
                        $("label[for='"+me.attr('id')+"']").addClass("animate-label");
                    }

                    $("label[for='"+me.attr('id')+"']").addClass("label-loaded");
                });

                inputs.blur(function(){
                    const me = $(this);

                    if ( me.val() == "" && !me.attr('disabled') && me.attr('readonly') === undefined ){
                        $("label[for='"+me.attr('id')+"']").removeClass("animate-label");
                    }
                }) ;

                inputs.focus(function(){
                    const me = $(this);

                    if ( !me.attr('disabled') && me.attr('readonly') === undefined ) {
                        $("label[for='"+me.attr('id')+"']").addClass("animate-label");
                    }
                });
            }
        }
    }

    vetSlidingLabels.addSlidingLabels(inputs);

    if ( selects.length > 0 ) {
        selects.each((index, element) => {
            const me = $(element);

            if ( me.find(':selected').val() == ""){
                $("label[for='"+me.attr('id')+"']").removeClass("animate-label");
            } else {
                $("label[for='"+me.attr('id')+"']").addClass("animate-label");
            }

            $("label[for='"+me.attr('id')+"']").addClass("label-loaded");
        });

        selects.blur(function(){
            const me = $(this);

            if ( me.find(':selected').val() == "" && !me.attr('disabled') && me.attr('readonly') === undefined ){
                $("label[for='"+me.attr('id')+"']").removeClass("animate-label");
            }
        });

        selects.focus(function(){
            const me = $(this);

            if ( !me.attr('disabled') && me.attr('readonly') === undefined ) {
                $("label[for='"+me.attr('id')+"']").addClass("animate-label");
            }
        });
    }

    $('body').on('vetAnimateFormLabels', (event, inputs) => {
        if (inputs) {
            vetSlidingLabels.addSlidingLabels(inputs);
        }
    });
});